export default "__VITE_ASSET__e9078c09__"